<span class=" d-block mb-2 subtitle-1--weight-regular">Refer a friend</span>
<div class="refer-a-friend p-3 p-md-4 mb-5">
    <div class="refer-a-friend__left mr-0 mr-md-3">
        <div class="refer-a-friend__title mb-2 d-flex justify-content-between">
            <div>                            
                <i class="fas fa-heart refer-a-friend__heart mr-2"></i>
                <span>Love Paybee?</span>
            </div>
            <button class="btn--paybee btn btn--refer-a-friend-dashboard" (click)="onReferAFriendClick()" id="referFriendsTop">Refer a Friend</button>
        </div>
        <div class="refer-a-friend__content body-2 mb-4 mb-md-0">
            <span>Refer PayBee to your non-profit friends. As a thank you, we will donate <b>$50</b> to you when they signup. Also, they will get a <b>$150</b> discount from the onboarding fee.</span>
        </div>
    </div>
 </div>